import { dropTrailingSlash } from './string.js';

export const generateQueryString = (
  queryObj: Record<string, string | null | undefined>,
) => {
  let queryStr = '';

  Object.keys(queryObj).forEach((key, index) => {
    const prefix = index === 0 ? '?' : '&';
    const value = queryObj[key];

    queryStr = `${queryStr}${prefix}${key}=${value}`;
  });

  return queryStr;
};

export const parseQueryString = (location: Location) => {
  const queryPairs = {} as Record<string, string | null | undefined>;

  if (!location.search) {
    return queryPairs;
  }

  const queryString = dropTrailingSlash(location.search.substring(1));

  const pairs = queryString.split('&');
  pairs.forEach((pair) => {
    const [key, value] = pair.split('=');

    queryPairs[key] = value;
  });

  return queryPairs;
};
